import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostInitiativeTaskRequest = {
	assignedOn: string;
	assignedTo: number;
	completed: boolean;
	completedBy: number;
	completedOn: string;
	initiativeId: number;
	name: string;
	orderIndex: number;
};

export type PostInitiativeTaskResponse = {
	initiativeTask: {
		initiativeTaskId: number;
	};
};

export const postInitiativeTask = createPostEndpoint<PostInitiativeTaskRequest, PostInitiativeTaskResponse>(
	({ initiativeId }) => `/api/v3/initiatives/${initiativeId}/tasks`
);
